<template>
  <div class="goods-detail-image">
    <div class="msg">
      <span>支持长按图片拖拽交换位置</span>，
      当前共{{ goodsItem.detailImages?.length }}张图片，
      商品详情图最多50张（格式要求：png、jpg、jpeg格式，大小不超过2M）
    </div>
    <div class="images">
      <div v-for="(item, index) in goodsItem.detailImages" :key="item" 
        @dragstart="handleDragStart(item)" draggable="true"
        @dragenter="handleDragEnter($event, item)"
        @dragover.prevent="handleDragOver"
        @drop.prevent
      >
        <ImageItem hide-size :key="item" :item="item" :index="index" @cropper="showVueCropper"
          @delete="deleteImage" @upload="showUploadComponent" />
      </div>
      <UploadImage :limit="{ count: goodsItem.detailImages.length, max: 50 }" :id="uploadId + goodsItem.index" v-show="goodsItem.detailImages?.length < 50" :imgFile='imgFile' @upload-image="showVueCropper" />
    </div>
    <a-modal width="900px" v-model:visible="visible" title="裁剪图片" 
      :footer='false' style="top: 60px" class="header-fixed-modal">
      <CropperImageModal :imgFile='imgFile' @cropper="cropperSuccess" @close="visible = false" />
    </a-modal>
  </div>
</template>
<script>
  import ImageItem from '../image_item'
  import CropperImageModal from '../vue_cropper'
  import UploadImage from '../upload_image'
  import { ShowUploadComponent } from '../utils'
  export default {
    components: { ImageItem, CropperImageModal, UploadImage },
    data() {
      return {
        goodsItem: { detailImages: [] },
        imgFile: { index: -1 },
        visible: false,
        uploadId: 'goods-detail-image-upload-image'
      }
    },
    methods: {
      showVueCropper(obj) {
        this.visible = true
        this.imgFile = obj
      },
      deleteImage(index) {
        this.goodsItem.detailImages = this.goodsItem.detailImages.filter((item, i) => i !== index)
        this.$message.success('删除商品详情图成功')
      },
      cropperSuccess(imgUrl) {
        const detailImages = this.goodsItem.detailImages
        if (this.imgFile.index === -1) {
          detailImages.push({})
          this.imgFile.index = detailImages.length - 1 
        } 
        const obj = detailImages[this.imgFile.index], imageElement = new Image()
        obj.img = imageElement.src = imgUrl
        imageElement.onload = () => {
          obj.width = imageElement.width
          obj.height = imageElement.height
          obj.isUpdate = true
        }
        this.visible = false
        this.imgFile.index = -1
        this.$message.success('已成功完成裁剪图片')
      },
      showUploadComponent(obj) {
        ShowUploadComponent(this, obj)
      },
      handleDragStart(item) {
        this.startItem = item //开始拖动时，暂时保存当前拖动的数据。
      },
      handleDragOver(e) {
        e.stopPropagation()
        e.preventDefault()
      },
      handleDragEnter(e, item) {
        e.dataTransfer.effectAllowed = "move"
        if (item == this.startItem) return
        const newItems = [...this.goodsItem.detailImages] // 拷贝一份数据进行交换操作。
        const prevIndex = newItems.indexOf(this.startItem) // 获取上一个下标
        const nextIndex = newItems.indexOf(item) // 获取下一个下标
        newItems[prevIndex] = item
        newItems[nextIndex] = this.startItem
        this.goodsItem.detailImages = newItems
      }
    }
  }
</script>
<style lang="less" scoped>
  @import './index';
</style>